export const LIST_TRANSACTIONS_API = {
  url: `/api/transactions_summaries/:id`,
  method: 'get',
}
